import { isEmpty } from "../../utils/FPEUtils";
import { useRecoilValue } from "recoil";
import { sigmetUnreadState, sigmetUnreadVisibleState } from "../../store/SigmetUnreadPositionState";
import { makeStyles } from "@material-ui/core/styles";
import unAnalyzedImg from "../../images/contents/map/sigmet/unanalyzed.png";
import useWindowSize from "../../hooks/useWindowSize";
import { weatherVisibleWithID, WX_ID_SIGMET } from "../../store/WeatherContentsState";
import { Tooltip, Typography, withStyles } from "@material-ui/core";
import { mapLegendVisibleState } from "../../store/MapLegendState";
import { routePointEditingState } from "../../store/RoutePointEditingState";

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    bottom: 5,
    left: 150,
    display: 'flex',
    justifyContent: 'center',
  },
  list: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    fontSize: '11px',
    fontWeight: 600
  },
  iconWrap: {
    display: "inline-block",
    verticalAlign: "middle"
  },
  icon: {
    verticalAlign: "middle"
  },
  label: {
    display: "inline-block",
    verticalAlign: "middle",
    textAlign: 'left',
    paddingRight: '5px',
  }
});

const UnreadTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#2e3a54',
    color: '#fff',
    fontSize: '16px',
    border: '1px solid #fff',
  },
  arrow: {
    color:'#2e3a54'
  }
}))(Tooltip);

function SigmetUnreadPositionPanel() {
  const sigmetVisible = useRecoilValue(weatherVisibleWithID(WX_ID_SIGMET));
  const sigmetUnreadPosition = useRecoilValue(sigmetUnreadState);
  const visibleSigmetUnread = useRecoilValue(sigmetUnreadVisibleState);
  const mapLegendVisible = useRecoilValue(mapLegendVisibleState);
  const routePointEditing = useRecoilValue(routePointEditingState);
  const windowSize = useWindowSize();
  const classes = useStyles();

  if (!sigmetVisible || !visibleSigmetUnread) return null;

  let width;
  const legendWidth = mapLegendVisible ? 500 : 0;
  let outerWidth = windowSize.width - (legendWidth + 150);
  let w = sigmetUnreadPosition.length * 110;

  if (outerWidth < 100) {
    outerWidth = width = 100;
  } else if (w > outerWidth) {
    width = outerWidth;
  } else {
    width = w;
  }

  return (
    <div className={classes.root} style={{width: outerWidth}}>
      <ul className={classes.list} style={{width}}>
        {sigmetUnreadPosition.map(unread => {
          const sigId = getSigmetText(unread);
          return (
            <li key={sigId}>
              <UnreadTooltip title={
                <>
                  <Typography color="inherit">{sigId}</Typography>
                  <hr/>
                  <Typography color="inherit">{unread.bltin}</Typography>
                </>
              } arrow placement="top" disableHoverListener={routePointEditing}>
                <span>
                  <span className={classes.iconWrap}><img src={unAnalyzedImg} alt="Unread position" className={classes.icon}/></span>
                  <span className={classes.label}>{sigId}</span>
                </span>
              </UnreadTooltip>
            </li>
          )
        })}
      </ul>
    </div>
  );
}

const getSigmetText = (prop) => {
  let f = '', e = '';
  const sigmetId = prop.sigmet_id;
  const areaIndicator = prop.area_indicator;

  if (!isEmpty(sigmetId)) {
    f = sigmetId.replace(/[0-9]/g, "").trim();
    e = sigmetId.replace(/[^0-9]/g, "").trim();
  }
  return f + '/' + areaIndicator + ' ' + e;
}


export default SigmetUnreadPositionPanel;